module.exports = __webpack_public_path__ + "static/media/Bhawna.b98daaa2.pdf";